// removed by extract-text-webpack-plugin
module.exports = {"UnderConstruction":"TopPlayers__UnderConstruction__2du6O","TopPlayers":"TopPlayers__TopPlayers__28iE5","TopSVG":"TopPlayers__TopSVG__3LPab"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/GameInfo/TopPlayers/TopPlayers.css
// module id = 255
// module chunks = 0